<div class="row">
  <div class="checkbox-input" [class.active]="isTicker">
    <div (click)="onIsTickerClick()">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
  </div>
  <span class="checkbox-label">TEXT IS TICKER</span>
</div>
<div class="row speed">
  <label>SPEED:</label>
  <icn-number-input
    [min]="0"
    [maxLength]="3"
    [step]="1"
    [value]="tickerSpeed"
    (valueChange)="onTextTickerSpeedChange($event)"
    class="number-input"
  >
  </icn-number-input>
  <span>sec.</span>
</div>
<div class="row">
  <label>DIRECTION:</label>
  <icn-dropdown
    [selectedValue]="tickerDirection"
    (selectedValueChange)="onTickerDirectionChange($event)"
  >
    <icn-dropdown-item title="LEFT" [value]="0"></icn-dropdown-item>
    <icn-dropdown-item title="RIGHT" [value]="1"></icn-dropdown-item>
    <icn-dropdown-item title="UP" [value]="2"></icn-dropdown-item>
    <icn-dropdown-item title="DOWN" [value]="3"></icn-dropdown-item>
  </icn-dropdown>
</div>
<!--<div class="row">-->
<!--<div class="checkbox-input" [class.active]="tickerIsLoop">-->
<!--<div (click)="onTickerIsLoopClick()">-->
<!--<svg viewBox="0 0 21.02 14.02">-->
<!--<path fill-rule="evenodd"-->
<!--d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"/>-->
<!--</svg>-->
<!--</div>-->
<!--</div>-->
<!--<span class="checkbox-label">LOOP</span>-->
<!--</div>-->
